import { render, staticRenderFns } from "./FormGroupTitle.vue?vue&type=template&id=33b954e0&scoped=true"
import script from "./FormGroupTitle.vue?vue&type=script&lang=js"
export * from "./FormGroupTitle.vue?vue&type=script&lang=js"
import style0 from "./FormGroupTitle.vue?vue&type=style&index=0&id=33b954e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b954e0",
  null
  
)

export default component.exports